import type { TierResult } from "detect-gpu";
import type { Breakpoint } from "../../hooks/useBreakpoint";

/**
 * Bloom / EffectComposer gate. Decision is driven by GPU tier, NOT by
 * breakpoint — a flagship phone keeps full effects; only genuinely weak
 * hardware drops them.
 */
export function shouldEnablePostprocessing(
  _bp: Breakpoint,
  gpu: TierResult,
): boolean {
  if (gpu.tier === 0) return false;
  if (gpu.isMobile && gpu.tier <= 1) return false;
  return true;
}

const SEGMENT_BASE: Record<Breakpoint, number> = {
  desktop: 1,
  tablet: 0.75,
  mobile: 0.6,
};

/** Multiplier applied to the instanced cloud segment count. */
export function cloudSegmentScale(bp: Breakpoint, gpu: TierResult): number {
  const base = SEGMENT_BASE[bp];
  return gpu.tier === 0 ? base * 0.7 : base;
}
